import { Button } from "@swiggy-private/dls-web-core/dist/components/Button";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const TitleText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.small,
    paddingRight: "60px",
}));

export const SubText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
    width: "100%",
}));

export const CTA = styled(Button)(({ theme }) => ({
    marginBottom: `calc(var(--sab, 0px) + ${theme.spacing.xLarge})`,
}));

export const PinInputContainer = styled.div(() => ({
    margin: "60px 0 48px 0",
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center",
}));
